// External Dependencies:
import React from 'react'

class Checkbox extends React.Component {
	handleChange = ( e ) => {
		this.props.onChange( this.props.id, e.target.checked )
	}

	render() {
		const { id, label, required, uncontrolled } = this.props
		let { value } = this.props

		if ( value === null ) {
			value = false
		}

		if ( uncontrolled ) {
			value = null
		}

		return (
			<div className="form-item form-checkbox">
				<input type="checkbox" name={ id } id={ id } checked={ value } onChange={ this.handleChange } />

				<div className="form-checkbox-replacement">
					<i className="icon-checkmark" aria-hidden="true"></i>
				</div>

				{ label &&
					<label htmlFor={ id }>
						<span dangerouslySetInnerHTML={ { __html: label } } />

						{ required &&
							<span className="-required"> *</span>
						}
					</label>
				}
			</div>
		)
	}
}

export default Checkbox



// WEBPACK FOOTER //
// ./components/Form/Checkbox.jsx